import { Alert } from "@mui/material";
import { useParams, useRouteError } from "react-router";

import { PageLayout } from "@/shared/components/PageLayout";
import { RobotoDomainException } from "@/shared/http";

/**
 * Top-most error boundary for the File route.
 *
 * Reference: https://reactrouter.com/en/main/route/error-element
 */
export function RouteErrorBoundary() {
  const { fileId } = useParams();
  const error = useRouteError();
  return (
    <PageLayout title={`Roboto - File - ${fileId}`}>
      <FileLoadAlert error={error} />
    </PageLayout>
  );
}

interface FileLoadAlertProps {
  error: unknown;
}

export function FileLoadAlert({ error }: FileLoadAlertProps) {
  if (error instanceof RobotoDomainException && error.isClientError()) {
    return (
      <Alert
        severity="error"
        sx={{
          fontSize: "1.125rem",
          margin: "1em 0",
        }}
      >
        {error.message}
      </Alert>
    );
  }

  return (
    <Alert
      severity="error"
      sx={{
        fontSize: "1.125rem",
        margin: "1em 0",
      }}
    >
      Something went wrong loading the file. Please try reloading the page.
    </Alert>
  );
}
